import logo from "./news-homepage-main/assets/images/logo.svg";
import open from "./news-homepage-main/assets/images/icon-menu.svg";
import close from "./news-homepage-main/assets/images/icon-menu-close.svg"
import { useState } from "react";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [iconImg, setIconimg] = useState(open);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        setIconimg(isMenuOpen ? open : close);
    }

    return ( 
        <header>
            <div className="logo">
                <img src={logo} alt="logo-img" id="logo-img"></img>
            </div>

            {/* destop nav */}
            <nav className="desktop-nav">
                <a href="/">Home</a>
                <a href="/">New</a>
                <a href="/">Popular</a>
                <a href="/">Trending</a>
                <a href="/">Category</a>
            </nav>

            {/* mobile nav */}
            <div className="mobile-nav">
                <button className="hamburger" onClick={toggleMenu}>
                    <img className="menu" src={iconImg} alt="menu"></img>
                </button>

                {/* links */}
                <div className={isMenuOpen ? 'links' : ''}>
                    {isMenuOpen && (
                        <>
                            <a href="/">Home</a>
                            <a href="/">New</a>
                            <a href="/">Popular</a>
                            <a href="/">Trending</a>
                            <a href="/">Category</a>
                        </>
                    )}
                </div>

            </div>
            
        </header>
     );
}
 
export default Header;